import { createSingleEntityStore } from '@core/ngrx-legacy';

const { actions, selectors, reducer, namespace } = createSingleEntityStore<{
  locations: string[];
}>()('InterviewEventsLocations');

export {
  actions as InterviewEventsLocationsActions,
  selectors as InterviewEventsLocationsSelectors,
  reducer as InterviewEventsLocationsReducer,
  namespace as InterviewEventsLocationsNamespace,
};
